/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrmOrg from './OrmOrg';

/**
 * The OrderQueryResultUser model module.
 * @module model/OrderQueryResultUser
 * @version 1.0
 */
class OrderQueryResultUser {
    /**
     * Constructs a new <code>OrderQueryResultUser</code>.
     * @alias module:model/OrderQueryResultUser
     */
    constructor() { 
        
        OrderQueryResultUser.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderQueryResultUser</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderQueryResultUser} obj Optional instance to populate.
     * @return {module:model/OrderQueryResultUser} The populated <code>OrderQueryResultUser</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderQueryResultUser();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('org')) {
                obj['org'] = OrmOrg.constructFromObject(data['org']);
            }
            if (data.hasOwnProperty('role')) {
                obj['role'] = ApiClient.convertToType(data['role'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
OrderQueryResultUser.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
OrderQueryResultUser.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
OrderQueryResultUser.prototype['id'] = undefined;

/**
 * @member {String} name
 */
OrderQueryResultUser.prototype['name'] = undefined;

/**
 * @member {module:model/OrmOrg} org
 */
OrderQueryResultUser.prototype['org'] = undefined;

/**
 * @member {String} role
 */
OrderQueryResultUser.prototype['role'] = undefined;

/**
 * @member {String} updatedAt
 */
OrderQueryResultUser.prototype['updatedAt'] = undefined;

/**
 * @member {String} username
 */
OrderQueryResultUser.prototype['username'] = undefined;






export default OrderQueryResultUser;

